import React from "react";
import JWORD from './jword4.js';
import './resources/css/jword4.css';

var $ = require("jquery");

export default class JWordComp extends React.Component
{
    componentDidMount() {
        this.$el = $(this.el);
        //this.$el.somePlugin();
        var options={
            jwordId:this.props.jwrId,
            'mode':'html','unit':'mm','viewMode':'normal',
            'equationURL':process.env.REACT_APP_JEQ_EP,lang:'en',
            license:'B85107567723A85BDE63D2FC2D03393B2852770F60E35F1449CB46300A874CF41BEEAF4AE99C82448E728910A052D232',
            defaultFont:this.props.defFont,
            defaultFontSize:this.props.defFontSize};
        if(this.props.mode=='temp')
        {
            options.pageSettings={pageSize:'A4',leftMargin:1440,rightMargin:1440,topMargin:1440,bottomMargin:1440,headerFromTop:200,footerFromBottom:200,orientation:'Portrait'};
        }
        else
        {
            options.pageSettings={pageSize:'A4',leftMargin:2000,rightMargin:2000,topMargin:1000,bottomMargin:1000,headerFromTop:200,footerFromBottom:200,orientation:'Portrait'};
        }
        this.jwordA = new JWORD(process.env.REACT_APP_JWR_EP,"/jwr",this.props.jwrId,options,this.props.onInit,this.props.onFocus);  
        this.jwordA.menuLoaded=true;
        this.jwordA.toolbarLoaded=true;  

        this.jwordA.sessionCallback=this.setSession;
        this.jwordA.equationCallback=this.openEquation;
        this.jwordA.openFieldCallback=this.openField;
        this.jwordA.modifiedCallback=this.onModified;
        this.state={modified:false};
    }
    
    componentWillUnmount() {
        //this.$el.somePlugin('destroy');
    }
    save=(objId,contentType)=>{
        const jwordComp=this;
        var ret = new Promise(function(resolve,reject){
            jwordComp.jwordA.saveCallback=function(saveInfo){
                console.log("saved document:"+saveInfo.sessionId+" dats:"+saveInfo.dats);
                jwordComp.setState({modified:false});
                resolve(saveInfo);
            }
            jwordComp.jwordA.jwordMenuAction("save",{objId:objId,contentType:contentType});
        });       
        return ret;
    }
    addCharListener=(listener)=>{this.jwordA.jmeAddCharListener(listener);}
    addParaListener=(listener)=>{this.jwordA.jmeAddParaListener(listener);}
    newDocument=()=>{this.jwordA.newDocument();}
    loadDocument=(datId)=>{this.jwordA.jwordMenuAction('loadDocument',{datId:datId});}
    undo=()=>{this.jwordA.undo();}
    redo=()=>{this.jwordA.redo();}
    cut=()=>{this.jwordA.editCut();}
    copy=()=>{this.jwordA.editCopy();}
    paste=()=>{this.jwordA.editPaste();}
    viewDraft=()=>{this.jwordA.setViewMode('draft');}
    viewNormal=()=>{this.jwordA.setViewMode('normal');}
    viewPage=()=>{this.jwordA.setViewMode('page');}
    setPageSettings=(ps)=>{this.jwordA.jwordMenuAction('setPageSettings',ps);}
    setColumnSettings=(cs)=>{this.jwordA.jwordMenuAction('setColumnSettings',cs);}
    formatSub=()=>{this.jwordA.jmeMenuAction('editch_sub');}
    indentMore=()=>{this.jwordA.indent();}
    indentLess=()=>{this.jwordA.outdent();}
    insertRow=()=>{this.jwordA.insertRow();}
    insertColumn=()=>{this.jwordA.insertColumn();}
    deleteRow=()=>{this.jwordA.deleteRow();}
    deleteColumn=()=>{this.jwordA.deleteColumn();}
    deleteTable=()=>{this.jwordA.deleteTable();}
    mergeCells=()=>{this.jwordA.mergeCells();}
    splitCells=()=>{this.jwordA.splitCells();}
    bold=()=>{this.jwordA.jmeMenuAction('editch_bold');}
    italic=()=>{this.jwordA.jmeMenuAction('editch_italic');}
    uline=()=>{this.jwordA.jmeMenuAction('editch_uline');}
    align=(a)=>{this.jwordA.jmeMenuAction('editpr_'+a);}
    insertText=(text)=>{this.jwordA.insertText(text);}
    insertTableAdvanced=(rows,cols,inset,border,backColor,tableWidth,columnWidths,data)=>{
        this.jwordA.insertTableAdvanced(rows,cols,inset,border,backColor,tableWidth,columnWidths,data);
    }
    fontSize=(fs)=>{
        var props={size:fs};
        this.jwordA.jwordMenuAction('setCharProps',props);
    }
    fontFace=(fs)=>{
        var props={face:fs};
        this.jwordA.jwordMenuAction('setCharProps',props);
    }    
    style=(fs)=>{
        var props={style:fs};
        this.jwordA.jwordMenuAction('setCharProps',props);
    }
    color=(c)=>{
        var props={color:c};
        this.jwordA.jwordMenuAction('setCharProps',props);
    }   
    backColor=(c)=>{
        var props={backColor:c};
        this.jwordA.jwordMenuAction('setCharProps',props);
    }       
    bullet=(bullet)=>{
        this.jwordA.setBullet(bullet);
    }       
    number=(num)=>{
        this.jwordA.setNumber(num);
    }
    charProps=(cp)=>{
        this.jwordA.jwordMenuAction('setCharProps',cp);
    }  
    paraProps=(pp)=>{
        this.jwordA.jwordMenuAction('setParaSettings',pp);
    }  
    borderInfo=(bi)=>{
        this.jwordA.jwordMenuAction('setBorderProps',bi);
    }
    getBorderInfo=()=>{
        //return this.jwordA.borderInfo;
    }
    getTableProps=(callback)=>{
        this.jwordA.getTableProps(callback);
    }
    setTableProps=(tp)=>{
        this.jwordA.jwordMenuAction('setTableProps',tp);
    }
    findAndReplace=(fr)=>{
        this.jwordA.jwordMenuAction('findReplace',fr)        
    }
    insertImage=(image)=>{        
        this.jwordA.insertImage(image);
    }
    insertImageChunked=(image,buffer)=>{        
        this.jwordA.insertImageChunked(image,buffer);
    }
    insertMediaPlaceholder=(imgData,hyperLink)=>{
        this.jwordA.jwordMenuAction('insertImage',{type:'image/png',name:'audio.png',autoScale:true,data:imgData,hyperLink:hyperLink});
    }
    setImageSettings=(props)=>{
        this.jwordA.jwordMenuAction('setPictureSettings',props);
    }
    getImageSettings=(callback)=>{
        this.jwordA.getPictureSettings(()=>callback(this.jwordA.pictureSettings));
    }
    focus=()=>{
        this.jwordA.jmeFocus();
    }
    zoom=(zoomVal)=>{this.jwordA.zoom(zoomVal)}
    
    insertTable=(tableInfo)=>{
        this.jwordA.insertTable(tableInfo.rows,tableInfo.cols);
    }
    insertEquation=(mathData,image,align,isnew)=>{
        this.jwordA.insertEquation(mathData,image,align,isnew);
    }
    questionTemplate=(optionFormat)=>{
        this.jwordA.jwordMenuAction('questionTemplate',optionFormat);
    }
    getOptions=()=>{
        return this.jwordA.options;
    }
    setSession=(sid)=>{
        if(this.props.setSession)
            this.props.setSession(sid);
    }
    insertMergeField=(name)=>{
        this.jwordA.jwordMenuAction('insertMergeField',{name:name});        
    }
    insertHeaderFooter=(name)=>{
        this.jwordA.insertHeaderFooter();        
    }

    getFields=(callback)=>{
        this.jwordA.getFields(callback);
    }
    openEquation=(mathData)=>{
        if(this.props.openEquation)
            this.props.openEquation(mathData);
    }
    openField=(field)=>{
        if(this.props.openField)
            this.props.openField(field);
    }
    onModified=()=>{
        this.setState({modified:true});
        if(this.props.onModified)
            this.props.onModified();
    }
    getMediaLinks=(callback)=>{
        this.jwordA.getMediaLinks(callback);
    }
    resize=()=>{
        var r = this.el.parentElement.getBoundingClientRect();
        var w = r.width-50;
        var h = r.height;
	    this.jwordA.jwordMenuAction('resize',{'viewWidth':w,'viewHeight':h});
    }
    render() {
        return( <>
        <div id={this.props.jwrId} ref={el => this.el = el} className={this.props.visible?"":"hidden"} style={{width:'100%',height:'100%'}}/>
        </>
        )
    }
}